import React from "react";
const SvgLoginAdBoost = props => (
  <svg fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="#F095A6"
      d="M20.226 18.508v5.922c0 .514-.284.987-.744 1.204L16.21 27.27c-.73.365-1.623 0-1.893-.784l-.866-2.583m-5.395-5.395l-2.582-.865c-.784-.257-1.15-1.15-.784-1.893l1.636-3.273a1.35 1.35 0 011.203-.743h5.922"
    />
    <path
      fill="#E4002B"
      d="M7.665 27.454L4 28l.546-3.663a2.742 2.742 0 012.306-2.305c1.826-.28 3.385 1.293 3.118 3.117a2.742 2.742 0 01-2.305 2.305z"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M25.909 5.5c-4.043 0-7.867 1.83-10.386 4.99l-5.838 7.303a.597.597 0 00.04.8l3.688 3.692a.595.595 0 00.798.039l7.297-5.841a.75.75 0 01.139-.089A13.33 13.33 0 0026.51 6.102a.606.606 0 00-.601-.602zM14.35 9.555A14.772 14.772 0 0125.909 4c1.158 0 2.101.945 2.101 2.102 0 4.5-2.05 8.759-5.55 11.565a.748.748 0 01-.144.09l-7.167 5.738c-.837.67-2.037.61-2.797-.15l-3.689-3.691a2.097 2.097 0 01-.15-2.797l5.838-7.302z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLoginAdBoost;
